import React, { useState } from "react";
import BarIcon2 from "../Logo-kuro.svg";
import { elastic as Menu } from "react-burger-menu";

export default function MenuBar() {
  return (
    <div className="menu-part">
      <a href="/" id="menu-button">
        <img className="menu-bar" src={BarIcon2} alt="" />
      </a>
      <Menu right>
        <a href="#works" className="menu-item">
          Works
        </a>
        <a href="#members" className="menu-item">
          Members
        </a>
        <a href="#access" className="menu-item">
          Access
        </a>
        <a href="#contact" className="menu-item">
          Contact
        </a>
      </Menu>
    </div>
  );
}
